import { Component, Input } from '@angular/core';
import { FormControl, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormField } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';

@Component({
  selector: 'app-multiselect-search-input',
  templateUrl: './multiselect-search-input.component.html',
  styleUrls: ['./multiselect-search-input.component.scss'],
  imports: [MatFormField, MatInput, FormsModule, ReactiveFormsModule],
})
export class MultiselectSearchInputComponent {
  @Input() searchControl = new FormControl('');

  onKeydown(event: KeyboardEvent, input: HTMLInputElement) {
    input.onkeydown?.(event);
    event.stopPropagation();
  }
}
